/**
 * Current Player ID Hook
 *
 * Provides the current player's userId. In production this comes from
 * BetterAuth session. In the test harness, a TestPlayerProvider overrides it
 * so PlayerViews render from the perspective of a fake test player.
 */

import { createContext, useContext } from "react";

import { useSession } from "../../lib/auth-client";

const TestPlayerContext = createContext<string | null>(null);

export { TestPlayerContext };

export function TestPlayerProvider({
  playerId,
  children,
}: {
  playerId: string;
  children: React.ReactNode;
}) {
  return <TestPlayerContext.Provider value={playerId}>{children}</TestPlayerContext.Provider>;
}

export function useCurrentPlayerId(): string {
  const testPlayerId = useContext(TestPlayerContext);
  const { data: session } = useSession();
  return testPlayerId || session?.user?.id || "";
}
